import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const reducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Button that magnetically follows the pointer while hovered.
 * Falls back to a plain button for touch devices / reduced motion.
 */
const MagneticButton = ({ children, className = "", strength = 0.35, ...props }) => {
  const ref = useRef(null);
  const xTo = useRef(null);
  const yTo = useRef(null);

  useGSAP(() => {
    if (reducedMotion()) return;
    xTo.current = gsap.quickTo(ref.current, "x", { duration: 0.5, ease: "power3.out" });
    yTo.current = gsap.quickTo(ref.current, "y", { duration: 0.5, ease: "power3.out" });
  }, { scope: ref });

  const onMove = (e) => {
    if (!xTo.current) return;
    const rect = ref.current.getBoundingClientRect();
    xTo.current((e.clientX - rect.left - rect.width / 2) * strength);
    yTo.current((e.clientY - rect.top - rect.height / 2) * strength);
  };

  const onLeave = () => {
    if (!xTo.current) return;
    xTo.current(0);
    yTo.current(0);
  };

  return (
    <button
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={className}
      {...props}
    >
      {children}
    </button>
  );
};

export default MagneticButton;
